












































import { Vue, Component, Prop } from "vue-property-decorator";

import formatCurrency from "@/filters/currency";
import Colors from "@/helpers/Colors";
import ReportModel from "@/model/Report";

import { namespace } from "vuex-class";

const formatCurrencyData = (v: number): GChartsCurrency => ({
  v,
  f: formatCurrency(v)
});

const chartOptions = {
  fontName: "Source Sans Pro",
  pieSliceText: "percent",
  pieSliceTextStyle: {
    color: "white",
    fontSize: 24
  },
  pieStartAngle: 0,
  height: "400px",
  chartArea: {
    width: "100%",
    height: "80%"
  },
  legend: {
    position: "labeled",
    labeledValueText: "value",
    textStyle: {
      color: "#000"
    }
  },
  tooltip: {
    trigger: "none"
  },
  slices: [
    { color: Colors.Secondary.hex(), offset: 0.01 },
    { color: Colors.PrimaryLight.hex(), offset: 0.01 },
    { color: Colors.PrimaryDark.hex(), offset: 0.01 }
  ]
};

const summaryChartData = [
  ["Obszar", "Kwota"],
  ["Świadczenia na rzecz organizacji ochrony zdrowia", 0],
  ["Świadczenia na rzecz przedstawicieli zawodów medycznych", 0],
  ["Świadczenia na działalność badawczo rozwojową", 0]
];

const hcoChartData = [
  ["Obszar", "Kwota"],
  ["Wynagrodzenie z tytułu świadczonych usług", 0],
  ["Koszty poniesione w związku z wydarzeniami", 0],
  ["Darowizny", 0]
];

const hcpChartData = [
  ["Obszar", "Kwota"],
  ["Wynagrodzenie z tytułu świadczonych usług", 0],
  ["Koszty poniesione w związku z wydarzeniami", 0]
];

const AppStore = namespace("App");

@Component({
  name: "AdminCharts"
})
export default class AdminCharts extends Vue {
  public chartOptions: {} = chartOptions;

  @Prop()
  readonly value!: ReportModel;

  @AppStore.State
  reportYear!: number;

  get summaryChartData(): Array<Array<any>> {
    Vue.set(summaryChartData[1], 1, formatCurrencyData(this.value.hcoTotal));
    Vue.set(summaryChartData[2], 1, formatCurrencyData(this.value.hcpTotal));
    Vue.set(summaryChartData[3], 1, formatCurrencyData(this.value.rndTotal));
    return summaryChartData;
  }
  get hcoChartData(): Array<Array<any>> {
    Vue.set(hcoChartData[1], 1, formatCurrencyData(this.value.hcoSalaryTotal));
    Vue.set(hcoChartData[2], 1, formatCurrencyData(this.value.hcoEventTotal));
    Vue.set(
      hcoChartData[3],
      1,
      formatCurrencyData(this.value.hcoDonationTotal)
    );
    return hcoChartData;
  }

  get hcpChartData(): Array<Array<any>> {
    Vue.set(hcpChartData[1], 1, formatCurrencyData(this.value.hcpSalaryTotal));
    Vue.set(hcpChartData[2], 1, formatCurrencyData(this.value.hcpEventTotal));
    return hcpChartData;
  }
}
